import { useEffect } from 'react';
import packageJson from '../../../package.json';
import { LOCAL_STORAGE_NAMES } from '../../constants/constants';

const APP_VERSION = packageJson.version;

const AppVersionSetter = () => {
  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_NAMES.csiAppVersion, APP_VERSION);
  }, []);
  return null;
};

export default AppVersionSetter;
